import React from 'react';
import ArticleShell from '@/components/resources/ArticleShell';
import { ARTICLES } from '@/data/resources/commercialCleanEnergy';

interface Props {
  articleKey: keyof typeof ARTICLES;
}

const CommercialCleanEnergyArticle: React.FC<Props> = ({ articleKey }) => {
  const article = ARTICLES[articleKey];
  if (!article) return null;
  const { meta, Body } = article;
  return (
    <ArticleShell meta={meta}>
      <Body />
    </ArticleShell>
  );
};

export default CommercialCleanEnergyArticle;
